import { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();

  const isActive = (path: string) => location.pathname === path;

  const navLinks = [
    { path: '/', label: 'Home' },
    { path: '/#events', label: 'Events' },
    { path: '/past-events', label: 'Past Events' },
    { path: '/#contact', label: 'Contact' },
    { path: '/#meetings', label: 'Meetings' },
    { path: '/oliver', label: 'Oliver: A Legacy in Green and Yellow' },
    { path: '/#park', label: 'Scotts Mill County Park' },
    { path: '/#donors', label: 'Donors & Sponsors', highlight: true },
    { path: '/donate', label: 'Make a Donation' },
  ];

  const handleNavClick = (path: string) => {
    setIsMenuOpen(false);
    if (path.startsWith('/#')) {
      const hash = path.substring(1);
      const element = document.querySelector(hash);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }
  };

  return (
    <>
      <Helmet>
        <link rel="preconnect" href="https://fonts.googleapis.com" />
        <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin="anonymous" />
      </Helmet>
      <header className="sticky top-0 z-50 shadow-md">
        <div className="bg-primary-blue-dark text-gray-100 py-6 px-4 text-center">
          <h1 className="font-vintage text-3xl md:text-4xl lg:text-5xl text-shadow-lg">
            Scotts Olde Tyme Power and Equipment Association
          </h1>
        </div>
        <nav className="bg-primary-blue">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="flex items-center justify-between h-16">
              {/* Mobile menu button */}
              <button
                className="md:hidden text-white p-2"
                onClick={() => setIsMenuOpen(!isMenuOpen)}
                aria-label="Toggle menu"
                aria-expanded={isMenuOpen}
              >
                <svg
                  className="h-6 w-6"
                  fill="none"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  {isMenuOpen ? (
                    <path d="M6 18L18 6M6 6l12 12" />
                  ) : (
                    <path d="M4 6h16M4 12h16M4 18h16" />
                  )}
                </svg>
              </button>

              {/* Desktop navigation */}
              <ul className="hidden md:flex flex-wrap items-center justify-center gap-2 lg:gap-4">
                {navLinks.map((link) => (
                  <li key={link.path}>
                    <Link
                      to={link.path}
                      onClick={() => handleNavClick(link.path)}
                      className={`px-3 py-2 rounded-md text-sm font-medium transition-colors ${
                        link.highlight
                          ? 'bg-red-500 text-white hover:bg-red-600 animate-pulse'
                          : isActive(link.path)
                          ? 'bg-primary-green text-white'
                          : 'text-white hover:bg-primary-blue-dark'
                      }`}
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            {/* Mobile navigation */}
            {isMenuOpen && (
              <div className="md:hidden py-4">
                <ul className="space-y-2">
                  {navLinks.map((link) => (
                    <li key={link.path}>
                      <Link
                        to={link.path}
                        onClick={() => handleNavClick(link.path)}
                        className={`block px-3 py-2 rounded-md text-base font-medium ${
                          link.highlight
                            ? 'bg-red-500 text-white'
                            : isActive(link.path)
                            ? 'bg-primary-green text-white'
                            : 'text-white hover:bg-primary-blue-dark'
                        }`}
                      >
                        {link.label}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            )}
          </div>
        </nav>
      </header>
    </>
  );
};

export default Header;



